import { useEffect, useState, useCallback } from "react";
import { useBlocker } from "react-router-dom";

export function useCallbackPrompt(
  when: boolean
): [boolean, () => void, () => void] {
  const blocker = useBlocker(when);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    setShowPrompt(blocker.state === "blocked");
  }, [blocker.state]);

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    blocker.proceed();
  }, [blocker]);

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    blocker.reset();
  }, [blocker]);

  return [showPrompt, confirmNavigation, cancelNavigation];
}
